import { EFacilityBlockableFeatures, IFacility } from '@zunta/configurations'

export const isFacilityFeatureBlocked = (facility: IFacility, feature: EFacilityBlockableFeatures) => {
  if (facility && EFacilityBlockableFeatures[feature]) {
    return facility.blockedFeatures && facility.blockedFeatures.includes(feature)
  }
  return false
}
